import app from "./app";
import game from "./game";

export default {
  app,
  game,
};
